import divider from 'url:../assets/animedivider.gif';
import '../styles/xanm.css';

export default function AnimeDivider () {
    return <img src={divider} className='anime-divider'/>
}